import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { RouterModule } from '@angular/router';
import { LibFormContainerModule } from '../form-container/form-container.module';
import { PasswordComponent } from './password/password.component';
import { ProfileComponent } from './profile.component';

@NgModule({
    imports: [CommonModule, FormsModule, RouterModule, LibFormContainerModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule],
    declarations: [ProfileComponent, PasswordComponent],
})
export class LibProfileModule {}
